import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';

import * as Sentry from '@sentry/react';

import App from './App';
import config from './config';
import * as serviceWorker from './serviceWorker';

Sentry.init({
  dsn: config.SENTRY_DSN,
  integrations: [],
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0,
  release: 'insurance-frontend@' + config.APP_VERSION,
  environment: config.SENTRY_ENV,
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'ChunkLoadError',
    // Avast extension error
    '_avast_submit',
    'Failed to fetch dynamically imported module'
  ],
  beforeSend(event: any, hint: any) {
    // reCaptcha modules throws these exact strings,Ignoring them as it doesn't affect users
    if (
      hint.originalException === 'Timeout' ||
      hint.originalException === 'Timeout (h)'
    )
      return null;
    return event;
  }
});

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
